export default __webpack_public_path__ + "static/TaskManager-9358a6c26961ac04914e4ddf42c3ef5c.png";